(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sindar-editorial-article"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sindar-editorial')) {
  customElements.define('sindar-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const body = this.querySelector('[data-se-body]');
      const nav = this.querySelector('[data-se-toc]');
      if (!body) return;
      if (this.dataset.faqCards === 'true' && !body.querySelector('.faq-category')) {
        let category = null, answer = null;
        [...body.children].forEach(node => {
          if (node.tagName === 'H2') {
            category = document.createElement('section');
            category.className = 'faq-category';
            node.before(category); category.append(node); answer = null;
          } else if (category && node.tagName === 'H3') {
            answer = document.createElement('div');
            answer.className = 'faq-answer';
            category.append(answer); answer.append(node);
          } else if (category) {
            (answer || category).append(node);
          }
        });
      }
      body.querySelectorAll('.faq-answer > h3').forEach((heading, index) => {
        if (heading.querySelector('.se-faq-number')) return;
        const number = document.createElement('span');
        number.className = 'se-faq-number';
        number.textContent = String(index + 1).padStart(2, '0') + '. ';
        heading.prepend(number);
      });
      if (this.dataset.numberChapters === 'true') {
        body.querySelectorAll('h2').forEach((heading, index) => {
          if (heading.querySelector('.se-chapter-number')) return;
          const number = document.createElement('span');
          number.className = 'se-chapter-number';
          number.textContent = String(index + 1).padStart(2, '0') + ' ';
          heading.prepend(number);
        });
      }
      const headings = [...body.querySelectorAll('h2,h3')];
      this.links = [];
      headings.forEach((heading, index) => {
        if (!heading.id || document.getElementById(heading.id) !== heading) heading.id = this.closest('[id]').id + '-heading-' + index;
        const a = document.createElement('a');
        a.href = '#' + encodeURIComponent(heading.id);
        a.textContent = heading.textContent;
        if (heading.tagName === 'H3') a.className = 'sub';
        if (nav) { nav.append(a); this.links.push(a); }
      });
      const panel = this.querySelector('.toc-column'), toc = this.querySelector('.toc');
      if (!headings.length && panel && this.dataset.designMode !== 'true') {
        panel.hidden = true;
        this.querySelector('.article-layout').classList.add('se-no-toc');
      }
      if (toc && matchMedia('(max-width: 700px)').matches) toc.open = false;
      this.addEventListener('shopify:block:select', event => {
        if (toc && panel?.contains(event.target)) toc.open = true;
      }, {signal});
      body.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('table-scroll')) return;
        const wrapper = document.createElement('div'); wrapper.className='table-scroll'; wrapper.tabIndex=0;
        table.before(wrapper); wrapper.append(table);
      });
      let current = -1;
      const update = () => {
        this.frame = 0;
        const header = document.querySelector('.sindar-global-header');
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, 200)) : 0;
        this.style.setProperty('--se-header-offset', headerBottom + 'px');
        const resources = this.querySelector('.resource-column');
        if (resources) resources.classList.toggle('se-resource-static', resources.offsetHeight > innerHeight - headerBottom - 100);
        const line = this.querySelector('.backbar').getBoundingClientRect().bottom + 75;
        let index=this.links.findIndex(a=>getComputedStyle(a).display!=='none');
        headings.forEach((h,i)=>{if(h.getBoundingClientRect().top<=line && this.links[i] && getComputedStyle(this.links[i]).display!=='none')index=i;});
        if(index!==current) {
          current=index;
          this.links.forEach((a,i)=>{if(i===index)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current');});
          const link=this.links[index], panel=this.querySelector('.toc-column');
          if(link && getComputedStyle(panel).position==='sticky'){
            const l=link.getBoundingClientRect(),p=panel.getBoundingClientRect();
            if(l.bottom>p.bottom-12)panel.scrollTop+=l.bottom-p.bottom+24;
            else if(l.top<p.top+12)panel.scrollTop-=p.top-l.top+24;
          }
        }
      };
      const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(update);};
      window.addEventListener('scroll',schedule,{passive:true,signal});
      window.addEventListener('resize',schedule,{passive:true,signal});
      this.observer=new ResizeObserver(schedule);this.observer.observe(body);
      nav?.addEventListener('click',event=>{
        const a=event.target.closest('a');if(!a)return;
        const target=document.getElementById(decodeURIComponent(a.hash.slice(1)));if(!target)return;
        event.preventDefault();
        const top=target.getBoundingClientRect().top+scrollY-this.querySelector('.backbar').getBoundingClientRect().bottom-25;
        window.scrollTo({top,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        history.replaceState(null,'',a.hash);
      },{signal});
      const copy=async()=>{
        try{await navigator.clipboard.writeText(this.dataset.shareUrl);const status=this.querySelector('[data-se-status]');if(status)status.textContent='Link copied';}
        catch{const input=this.querySelector('[data-se-copy-fallback]');if(input){input.hidden=false;input.value=this.dataset.shareUrl;input.focus();input.select();}}
      };
      this.querySelectorAll('[data-se-copy]').forEach(button=>button.addEventListener('click',copy,{signal}));
      this.querySelectorAll('[data-se-share]').forEach(button=>button.addEventListener('click',async()=>{
        if(navigator.share){try{await navigator.share({title:this.dataset.title,url:this.dataset.shareUrl});}catch(e){if(e.name!=='AbortError')await copy();}}
        else await copy();
      },{signal}));
      schedule();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);this.abort=null;this.querySelector('[data-se-toc]')?.replaceChildren();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
